var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M58.3335 52.5004L40.8335 52.5004M49.5835 43.7504V61.2504M37.9168 41.6792C36.0685 41.1291 34.1105 40.8337 32.0835 40.8337C20.8077 40.8337 11.6668 49.9746 11.6668 61.2504H33.5418M43.7501 20.417C43.7501 26.8604 38.5268 32.0837 32.0835 32.0837C25.6402 32.0837 20.4168 26.8604 20.4168 20.417C20.4168 13.9737 25.6402 8.75037 32.0835 8.75037C38.5268 8.75037 43.7501 13.9737 43.7501 20.417Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c19b4ec36b4835f3733317ec9de35354.svg";
export { ForwardRef as ReactComponent };